import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import { thunk } from 'redux-thunk';

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
});
